import { baseZIndex } from 'components/GridTable/consts'
import { GridTableVisibleColumnsContext } from 'components/GridTable/context'
import { useContext } from 'react'
import { colors } from 'settings/colors'
import type { GridTableColumn } from '../../types'
import { Cell } from './Cell/Cell'

export const Right = ({
  columns,
  widthForValueColumns,
}: {
  columns: GridTableColumn[]
  widthForValueColumns: number
}) => {
  const { startIndex, endIndex } = useContext(GridTableVisibleColumnsContext)

  return (
    <div
      css={{
        float: 'left',
        backgroundColor: colors.white,
        boxSizing: 'border-box',
        display: 'flex',
        zIndex: baseZIndex - 3,
        width: widthForValueColumns * columns.length,
        borderLeft: `2px solid ${colors.grey200}`,
        paddingTop: 20,
      }}
    >
      <div css={{ display: 'flex' }}>
        <div css={{ flexShrink: 0, width: startIndex * widthForValueColumns }} />
        {columns.slice(startIndex, endIndex).map((columns) => {
          return (
            <Cell key={columns.key} column={columns} widthForValueColumns={widthForValueColumns}>
              {columns.title}
            </Cell>
          )
        })}
      </div>
    </div>
  )
}
